import { ReactElement } from 'react';

import {
  RdGroupingTicketOrCollection,
  RdProjectTpTicketsViewSortFields,
  SortDirection,
  SortNulls,
  GroupedTicketsBase,
} from '@neo.tax/shared';

import { useTicketsForRdProject } from '../../hooks';

type GroupingSelection = {
  isGroupingSelected: boolean;
  selectedTicketIds: Set<string>;
};

export interface RdGroupedTicketsProps {
  rdProjectId: string;
  groupingTicketOrCollection: RdGroupingTicketOrCollection;
  groupingSelections: Record<string, GroupingSelection>;
  setGroupingSelections: React.Dispatch<React.SetStateAction<Record<string, GroupingSelection>>>;
  searchKeyword: string | null;
  isMoveTicketsDisabled: boolean;
  onTicketCountChange?: (groupingId: string, count: number) => void;
}

export const RdGroupedTickets = ({
  groupingSelections,
  groupingTicketOrCollection,
  isMoveTicketsDisabled,
  onTicketCountChange,
  rdProjectId,
  searchKeyword,
  setGroupingSelections,
}: RdGroupedTicketsProps): ReactElement => {
  const { hasNextPage, loadMore, loading, tickets } = useTicketsForRdProject({
    rdProjectId,
    searchKeyword,
    groupingTicketOrCollection,
    sorting: {
      direction: SortDirection.Desc,
      field: RdProjectTpTicketsViewSortFields.CompletedDatetime,
      nulls: SortNulls.NullsLast,
    },
  });

  return (
    <GroupedTicketsBase
      groupingId={groupingTicketOrCollection.id}
      tickets={tickets}
      hasNextPage={hasNextPage}
      loadMore={loadMore}
      loading={loading}
      groupingSelections={groupingSelections}
      setGroupingSelections={setGroupingSelections}
      isMoveTicketsDisabled={isMoveTicketsDisabled}
      onTicketCountChange={onTicketCountChange}
    />
  );
};
